import React from 'react';
import { Item, ItemLogger } from '../../containers/commerce';
import ProductViewPage1 from '../../components/commerce/ProductViews/ProductViewPage1';

export default ({
  varenr,
  menuPicker,
  activeSidemenu,
}) => (
  <React.Fragment>
    <Item
      varenr={varenr}
      display={ProductViewPage1}
      menuPicker={menuPicker}
      activeSidemenu={activeSidemenu}
    />
    <ItemLogger varenr={varenr} />
  </React.Fragment>
);
